import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import {
  FramerTooltip,
  HUB_TOOLTIP_MOUSE_LEAVE_DELAY,
  HubRelatedRideTooltipContent,
} from "@ryde/controls";
import { useRideHubInfo } from "@ryde/redux";
import { editFormDataAF, IRideDto, RideCrudModeKeyTuple } from "@ryde/shared";

import { TabsBottomInfoItemStyled } from "../../../../../right";

export const RideHubInfoIndicator: FC = () => {
  const { t } = useTranslation();
  const rideDto = useRecoilValue<Partial<IRideDto> | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );
  const hubInfo = useRideHubInfo(rideDto);

  if (!hubInfo) {
    return null;
  }

  const { hasMain, hasPersonal, hasCompanionPassengers } = hubInfo;
  const MainIcon = hasCompanionPassengers
    ? SVG_MUI.HubMainCompanion4SVG
    : SVG_MUI.HubMain4SVG;
  const PersonalIcon = hasCompanionPassengers
    ? SVG_MUI.HubPersonalCompanion4SVG
    : SVG_MUI.HubPersonal4SVG;

  return (
    <>
      {hasMain && (
        <TabsBottomInfoItemStyled>
          <FramerTooltip
            content={
              <HubRelatedRideTooltipContent
                rideDto={rideDto}
                segment="main"
                hasCompanionPassengers={hasCompanionPassengers}
              />
            }
            placement={PopoverPlacement.bottom}
            mouseLeaveDelay={HUB_TOOLTIP_MOUSE_LEAVE_DELAY}
          >
            <div className="item__content ride-header-hub">
              <MainIcon className="ride-header-hub-icon" />
              <label>{t("ride.HUB_MAIN")}</label>
            </div>
          </FramerTooltip>
        </TabsBottomInfoItemStyled>
      )}
      {hasPersonal && (
        <TabsBottomInfoItemStyled>
          <FramerTooltip
            content={
              <HubRelatedRideTooltipContent
                rideDto={rideDto}
                segment="personal"
                hasCompanionPassengers={hasCompanionPassengers}
              />
            }
            placement={PopoverPlacement.bottom}
            mouseLeaveDelay={HUB_TOOLTIP_MOUSE_LEAVE_DELAY}
          >
            <div className="item__content ride-header-hub">
              <PersonalIcon className="ride-header-hub-icon" />
              <label>{t("ride.HUB_PERSONAL")}</label>
            </div>
          </FramerTooltip>
        </TabsBottomInfoItemStyled>
      )}
    </>
  );
};
